import { render, staticRenderFns } from "./NotificationSnackbar.vue?vue&type=template&id=eefb5542&"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js&"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports